import Collection from '../../collection';
import UserType from '../../model/refbooks/user.type';

export default Collection.extend( {
	endpoint: 'users/types/list?apiVersion=2.0&limit=1000000',
    model: UserType
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/user.types.js